import React from 'react';
import {
  TableRow,
  TableCell,
  Box,
  TextField,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';

const GeneralForm = ({ formData, errors, handleInputChange }) => {
  return (
    <>
      {Object.entries(formData.general).map(([key, value]) => (
        <TableRow
          key={key}
          data-error={!!errors.general[key]}
          sx={{
            backgroundColor: errors.general[key] ? 'rgba(255, 0, 0, 0.05)' : 'inherit'
          }}
        >
          <TableCell component="th" sx={{ fontWeight: 'bold' }}>
            {key === 'cr_project_name' ? 'CR/Project Name' : key.replace(/_/g, ' ').toUpperCase()}
          </TableCell>
          <TableCell colSpan={3}>
            {key === 'validity_period' ? (
              <Box>
                <Select
                  fullWidth
                  name={key}
                  value={value}
                  onChange={(e) => handleInputChange(e, 'general', key)}
                  error={!!errors.general[key]}
                >
                  <MenuItem value="90">90 days</MenuItem>
                  <MenuItem value="180">180 days</MenuItem>
                </Select>
                {errors.general[key] && (
                  <FormHelperText error>{errors.general[key]}</FormHelperText>
                )}
              </Box>
            ) : key === 'environment' ? (
              <Box>
                <Select
                  fullWidth
                  name={key}
                  value={value}
                  onChange={(e) => handleInputChange(e, 'general', key)}
                  error={!!errors.general[key]}
                >
                  <MenuItem value="production">Production</MenuItem>
                  <MenuItem value="testbed">Testbed</MenuItem>
                </Select>
                {errors.general[key] && (
                  <FormHelperText error>{errors.general[key]}</FormHelperText>
                )}
              </Box>
            ) : (
              <Box>
                <TextField
                  fullWidth
                  name={key}
                  value={value}
                  onChange={(e) => handleInputChange(e, 'general', key)}
                  error={!!errors.general[key]}
                  helperText={errors.general[key]}
                />
              </Box>
            )}
          </TableCell>
        </TableRow>
      ))}
      {errors.general.test_data && (
        <TableRow
          data-error="true"
          sx={{ backgroundColor: 'rgba(255, 0, 0, 0.05)' }}
        >
          <TableCell colSpan={4}>
            <Box sx={{ color: 'error.main', mt: 1, mb: 1 }}>
              {errors.general.test_data}
            </Box>
          </TableCell>
        </TableRow>
      )}
      {errors.general.total_quantity && (
        <TableRow
          data-error="true"
          sx={{ backgroundColor: 'rgba(255, 0, 0, 0.05)' }}
        >
          <TableCell colSpan={4}>
            <Box sx={{ color: 'error.main', mt: 1, mb: 1, fontWeight: 'bold' }}>
              {errors.general.total_quantity}
            </Box>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default GeneralForm;
